import React, { useState } from 'react';
import cx from 'classnames';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Spinner } from 'app/src/components/Spinner';
import { useUpdateCardCoverMutation } from '@trello/graphql/generated';
import parseURL from 'url-parse';
import styles from './SearchResultImageButton.less';
import { track } from '@trello/analytics';
import { getUnsplashApi } from '@trello/unsplash';

const format = forTemplate('card_cover_chooser');
const PhotoAttributionComponent = require('app/scripts/views/board-create/photo-attribution-component');

const RAW_PARAMS = {
  w: 2560,
  h: 2048,
  q: 90,
};

interface SearchResultImageButtonProps {
  cardId: string;
  index: number;
  urls: { thumb: string; raw: string };
  user: { name: string; links: { html: string } };
  links: { download_location: string };
  onSetCover: () => void;
}

export const SearchResultImageButton: React.FunctionComponent<SearchResultImageButtonProps> = ({
  cardId,
  index,
  urls,
  links,
  user,
  onSetCover,
}) => {
  const [updateCardCover] = useUpdateCardCoverMutation();
  const [isUploading, setIsUploading] = useState(false);

  function parseBackgroundUrl(link: string) {
    const url = parseURL(link, true);
    url.set('query', { ...url.query, ...RAW_PARAMS });

    return url.toString();
  }

  const setCover = async (cover: { url: string }) => {
    await updateCardCover({
      variables: {
        cardId,
        cover,
      },
    });

    // Send Unsplash an analytics event
    getUnsplashApi().photos.downloadPhoto({ links });
  };

  const coverButtonOverlay = () => {
    if (isUploading) {
      return (
        <div className={styles.upload}>
          <Spinner inline modLeft small text={format('uploading-ellipsis')} />
        </div>
      );
    } else {
      return <PhotoAttributionComponent user={user} />;
    }
  };

  return (
    <div key={index} className={styles.backgroundGridItem}>
      <button
        className={cx('button', styles.coverTilesItem)}
        style={{
          backgroundImage: `url('${urls.thumb}')`,
        }}
        onClick={async () => {
          setIsUploading(true);
          await setCover({
            url: parseBackgroundUrl(urls.raw),
          });
          onSetCover();
          track('Card Cover Chooser', 'Choose Unsplash Search Result');
        }}
      >
        {coverButtonOverlay()}
      </button>
    </div>
  );
};
